import { render } from "./LeftPanelNavigationComponent.vue?vue&type=template&id=e062e700&scoped=true"
import script from "./LeftPanelNavigationComponent.vue?vue&type=script&lang=js"
export * from "./LeftPanelNavigationComponent.vue?vue&type=script&lang=js"

import "./LeftPanelNavigationComponent.vue?vue&type=style&index=0&id=e062e700&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e062e700"]])

export default __exports__